import Vue from 'vue'
import VueRouter from 'vue-router'

import Index from '../pages/index'
import Login from '../pages/login'
import Line from '../pages/line'
import Blank from '../pages/blank'

//1 注入
Vue.use(VueRouter)

//2 定义路由
const routes = [
  // 添加默认映射
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    component: Index
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/blank',
    component: Blank
  },
  {
    path: '/line',
    component: Line
  }
]

//3 创建router实例
const router = new VueRouter({
  routes
})

//4 导出 (到main.js挂载)
export default router
